webpackJsonp([263791100135453],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var about = function about() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "width-container" },
	      _react2.default.createElement(
	        "div",
	        { className: "width-container-about-video" },
	        _react2.default.createElement(
	          "div",
	          { className: "about__video" },
	          _react2.default.createElement(
	            "video",
	            { className: "about__video__content", autoPlay: true, muted: true, loop: true },
	            _react2.default.createElement("source", { src: "https://res.cloudinary.com/duwpl9hjf/video/upload/v1524578895/miguel-bettencourt-website/about/video.mp4", type: "video/mp4" }),
	            "Your browser is not supported!"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "about__text" },
	          _react2.default.createElement(
	            "p",
	            null,
	            "Born In the Azores, Portugal, Miguel moved to mainland Portugal in 2011 to complete his Bachelor's Degree in visual arts and Masters degree in animation in 2016. Since then, Miguel has worked as a Professional Animator in studios in Portugal, Canada and in Ireland, having his work broadcasted in major entertainment channels including Netflix, Amazon Prime, Apple TV and Disney Channel. Other than animation, Miguel loves exploring concepts of self care, skateboarding culture and cow appreciation through the mediums of illustration and painting."
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = about;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-aa6fe2cc22fd71377a4d.js